import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import { Formik, useFormikContext } from 'formik';

import { BootstrapTable } from '@components/Table/Table';
import { profileApi } from '@reducers/profile/profile';

const renderDidCell = ({ row, value, didsActions }) => {
  const { original } = row;
  return (
    <span
      onClick={() => {
        if (didsActions.default.dids.includes(original)) {
          didsActions.default.setValue(
            didsActions.default.dids.filter((item) => item !== original)
          );
          didsActions.details.setValue([...didsActions.details.dids, original]);
          return;
        }
        if (didsActions.details.dids.includes(original)) {
          didsActions.details.setValue(
            didsActions.details.dids.filter((item) => item !== original)
          );
          didsActions.default.setValue([...didsActions.default.dids, original]);
        }
      }}
      style={{ cursor: 'pointer' }}
      role="button"
      aria-hidden="true"
    >
      {value}
    </span>
  );
};

const renderDidHeader = () => {
  const { handleChange, handleBlur, values } = useFormikContext();
  return (
    <Form.Group className="mb-3" controlId="formGroupDID">
      <Form.Label>DID</Form.Label>
      <Form.Control
        type="input"
        name="did"
        size="sm"
        value={values.did}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Search"
      />
    </Form.Group>
  );
};

const renderProfileHeader = () => {
  const profiles = profileApi.useGetForSelectQuery();
  const { handleChange, handleBlur, values } = useFormikContext();
  return (
    <Form.Group className="mb-3" controlId="formGroupProfile">
      <Form.Label>End user</Form.Label>
      <Form.Select
        name="profile"
        size="sm"
        value={values.profile}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={profiles.isLoading || profiles.isError}
      >
        <option value="">Select end user</option>
        {!profiles.isLoading &&
        !profiles.isError &&
        profiles.data.length > 0 ? (
          <>
            {profiles.data.map((item) => (
              <option key={item.value} value={item.name}>
                {item.name}
              </option>
            ))}
          </>
        ) : null}
      </Form.Select>
    </Form.Group>
  );
};

export const DidGroupsDetailsTable = ({
  name,
  dids,
  didsActions,
  withActions = false,
}) => {
  const columns = useMemo(
    () => [
      {
        id: 'id',
        accessor: 'id',
      },
      {
        id: 'did',
        Header: renderDidHeader,
        accessor: 'did',
        className: 'col-md-6',
        Cell: ({ row, value }) =>
          withActions ? renderDidCell({ row, value, didsActions }) : value,
        filter: (rows, id, filterValue) =>
          filterValue
            ? rows.filter((row) =>
                String(row.original.did).includes(filterValue)
              )
            : rows,
      },
      {
        id: 'profile',
        Header: renderProfileHeader,
        accessor: 'profile',
        className: 'col-md-6',
        filter: (rows, id, filterValue) =>
          filterValue
            ? rows.filter((row) => String(row.original.profile) === filterValue)
            : rows,
      },
    ],
    [dids, didsActions, name]
  );
  return (
    <Formik
      enableReinitialize
      initialValues={{ did: '', profile: '' }}
      onSubmit={() => {}}
    >
      {({ values }) => (
        <BootstrapTable
          tableHeader={`DID-Group - ${name}`}
          columns={columns}
          data={dids}
          filterData={values}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          hiddenColumns="id"
        />
      )}
    </Formik>
  );
};
